var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRistrutturazioneUfficiSedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    id: "svg10",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "m 22.633401,27.104179 c -2.18761,-0.220182 -3.613419,-0.538796 -4.583348,-1.024201 -0.776701,-0.388707 -1.195007,-1.121287 -1.458935,-2.555038 -0.164303,-0.892557 -0.135878,-4.548652 0.04784,-6.152394 0.405538,-3.540242 1.153198,-7.125613 1.899573,-9.1093218 0.861346,-2.2892792 2.596319,-3.1456892 6.384031,-3.1512562 1.946688,-0.00289 3.464366,0.2658273 4.440617,0.7861626 0.603032,0.321414 1.347568,1.1027254 1.679326,1.7622803 0.743054,1.4772374 1.686701,5.6116341 2.096489,9.1853481 0.561973,4.900887 0.232289,8.101637 -0.925441,8.98468 -0.598853,0.456767 -1.892294,0.853373 -3.651369,1.119614 -0.850276,0.128692 -5.087155,0.238835 -5.928775,0.154126 z",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "m 12.34759,26.605226 c -0.972491,-6.28e-4 -1.294427,-0.09982 -1.66876,-0.514163 -0.270857,-0.299806 -0.30745,-0.393766 -0.307168,-0.788718 3.78e-4,-0.530194 0.208145,-0.925008 0.618411,-1.175151 0.237945,-0.145076 0.431521,-0.169846 1.329498,-0.170118 1.115477,-3.39e-4 1.703455,-0.07194 1.694076,0.440173 -0.01293,0.705562 0.0206,1.260267 -0.02604,1.637273 -0.04734,0.382621 -0.185267,0.58221 -1.640017,0.570704 z",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 16.305338,34.818631 c -0.190613,-0.08658 -0.482446,-0.316158 -0.648517,-0.510176 -0.694357,-0.811197 -0.657197,-1.810679 0.09624,-2.588863 0.688079,-0.710674 0.203377,-0.677142 9.407469,-0.650829 l 8.068647,0.02306 0.341798,0.184438 c 0.713328,0.384914 1.068124,0.976694 1.068124,1.78157 0,0.551837 -0.188214,0.977323 -0.612023,1.38357 -0.272166,0.260887 -0.306935,0.469589 -1.144476,0.465147 z",
    id: "path1"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09253e",
    cx: 17.356695,
    cy: 43.627792,
    r: 1.2602668,
    id: "circle5",
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09253e",
    cx: 24.918299,
    cy: 43.627792,
    r: 1.2602668,
    id: "circle6",
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09253e",
    cx: 32.4799,
    cy: 43.627792,
    r: 1.2602668,
    id: "circle7",
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 17.356694,42.247462 c 0.648677,-4.139597 14.458276,-4.015773 15.123205,0",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 24.967157,35.663398 v 6.225424",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 22.847026,29.185325 h 4.187046",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 13.987607,25.213218 v 5.020224 l 1.809992,1.236746",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 35.986351,25.213218 v 5.020224 l -1.667584,1.371383",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "m 37.652408,26.605226 c 0.972491,-6.28e-4 1.294428,-0.09982 1.66876,-0.514163 0.270857,-0.299806 0.30745,-0.393766 0.30717,-0.788718 -3.79e-4,-0.530194 -0.208146,-0.925008 -0.618413,-1.175151 -0.237944,-0.145076 -0.431521,-0.169846 -1.329498,-0.170118 -1.115477,-3.39e-4 -1.703455,-0.07194 -1.694076,0.440173 0.01293,0.705562 -0.0206,1.260267 0.02604,1.637273 0.04734,0.382621 0.185266,0.58221 1.640017,0.570704 z",
    id: "path1-6"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRistrutturazioneUfficiSedia);
export default __webpack_public_path__ + "static/media/ristrutturazione_uffici_sedia.65769545b5911b7be08e39c7ce30e9c4.svg";
export { ForwardRef as ReactComponent };